import { Link, useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Button } from '@components/button';

import Heading from './Heading';
import { useStore } from 'models/stores';

export default observer(({ closeModal }) => {
  const {
    uiStore: { t, language },
    companyStore: {
      current: { name },
    },
  } = useStore();
  const { search } = useLocation();

  const dashLink = `/${name}/${language}${search}`;

  return (
    <SuccessModalWrapper>
      <Heading>{t('apply_successModal_title')}</Heading>
      <div>{t('apply_successModal_text')}</div>
      <Link to={dashLink} onClick={closeModal} style={{ display: 'inline-block' }}>
        <Button text={t('apply_successModal_backToJobs')} />
      </Link>
    </SuccessModalWrapper>
  );
});

const SuccessModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  color: ${(p) => p.theme.textColor};
  font-size: 16px;
  font-family: ${(p) => p.theme.fontFamily};
`;
